import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import {useEffect} from 'react';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './services.css';

const Services = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Services" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / Services
                </p>
            </PageHeader>
            <section className='services'>


                <div className="services-content">
                    <div className="services-content-container">
                        <div className="services-content">
                            <div className="services-content-header">
                                <h1>
                                    Our Services
                                </h1>
                                <p>
                                    Welcome to PestEX Masters, the premier pest control service in Kenya! We offer a wide range of
                                    pest control services to meet all of your pest control needs. Whether you are dealing with a small
                                    infestation or a larger pest problem, our team of expert pest control technicians are here to help.
                                </p>
                            </div>
                            <div className="sevices-content-examples">
                                <div className="services-content-sample residential-pest-control-services-content">
                                    <Link to='/residential-pest-control'>
                                        <h2>
                                            Residential <br/> Pest Control
                                        </h2>
                                        <p>
                                            We understand the importance of keeping your home pest-free. Our residential pest control services are
                                            designed to eliminate pests like ants, bed bugs, rodents, and termites from your home, so you can rest
                                            easy knowing your family is protected.
                                        </p>
                                    </Link>
                                </div>
                                <div className="services-content-sample commercial-pest-control-services-content">
                                    <Link to='/commercial-pest-control'>
                                        <h2>
                                            Commercial <br/> Pest Control
                                        </h2>
                                        <p>
                                            At PestEX Masters, we know that pests can be a major problem for businesses. Our commercial pest
                                            control services are designed to eliminate pests like cockroaches, rodents, and termites from your
                                            business, so you can maintain a clean and healthy work environment.
                                        </p>
                                    </Link>
                                </div>
                                <div className="services-content-sample">
                                    <h2>
                                        Bed Bug Treatment
                                    </h2>
                                    <p>
                                        Bed bugs are a growing problem in Nairobi, and they can be difficult to eliminate without professional
                                        help. Our bed bug treatment services are designed to eliminate bed bugs from your home or business,
                                        so you can get a good night's sleep.
                                    </p>
                                </div>
                                <div className="services-content-sample">
                                    <h2>
                                        Termite Control
                                    </h2>
                                    <p>
                                        Termites can cause significant damage to your home or business if left unchecked. Our termite control
                                        services are designed to eliminate termites from your property and prevent future infestations, so you
                                        can protect your investment.
                                    </p>
                                </div>
                                <div className="services-content-sample">
                                    <h2>
                                        Rodent Control
                                    </h2>
                                    <p>
                                        Rodents like rats and mice can cause significant damage to your home or business, and they can also
                                        spread diseases. Our rodent control services are designed to eliminate rodents from your property and
                                        prevent future infestations, so you can maintain a safe and healthy environment.
                                    </p>
                                </div>
                            </div>
                            <h2>
                                Why Choose PestEX Masters?
                            </h2>
                            <p>
                                Experienced Pest Control Technicians: Our team of expert pest control technicians has years of
                                experience in the industry, and they have the knowledge and expertise to eliminate even the toughest
                                pest problems.
                                Customized Pest Control Solutions: We understand that every pest problem is unique, which is why we
                                offer customized pest control solutions to meet your specific needs.
                            </p>
                            <p>
                                Safe and Effective Pest Control Methods: At PestEX Masters, we use safe and effective pest control
                                methods to eliminate pests from your property without causing harm to people or pets.
                                Affordable Pricing: We offer competitive pricing on all of our pest control services, so you can get thepest control you need without breaking the bank.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container services_container">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default Services